import { render, staticRenderFns } from "./ShiftToolbar.vue?vue&type=template&id=f5e87b8a"
import script from "./ShiftToolbar.vue?vue&type=script&lang=js"
export * from "./ShiftToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports